/* Yukon Bags mega menu · v1.0 · no dependencies */
(function () {
  'use strict';
  if (window.ybNavReady) return;
  window.ybNavReady = true;

  var docEl = document.documentElement;
  docEl.classList.add('yb-js');
  var desktopMq = window.matchMedia('(min-width: 1024px)');
  var hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');
  var OPEN_DELAY = 180, CLOSE_DELAY = 260;

  /* ---------------- Desktop mega menu ---------------- */
  function initDesktop(nav) {
    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-yb-item]'));
    var openItem = null, openTimer = null, closeTimer = null;
    var header = nav.closest('.site-header') || nav.parentNode;
    var row = nav.closest('.yb-row') || nav;
    header.addEventListener('mouseleave', function () {
      if (!openItem || !desktopMq.matches || !hoverMq.matches) return;
      var it = openItem;
      closeTimer = setTimeout(function () { close(it); }, CLOSE_DELAY);
    });
    header.addEventListener('mousemove', function (e) {
      // Pointer back on the row but outside every item: close after the delay.
      if (!openItem || !desktopMq.matches || !hoverMq.matches) return;
      if (e.clientY < row.getBoundingClientRect().bottom - 4 && !e.target.closest('[data-yb-item]')) {
        clearTimeout(closeTimer); var it = openItem;
        closeTimer = setTimeout(function () { close(it); }, CLOSE_DELAY);
      }
    });

    function setOpen(item, open) {
      var btn = item.querySelector('.yb-toggle');
      item.classList.toggle('is-open', open);
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function open(item) {
      clearTimeout(closeTimer); clearTimeout(openTimer);
      if (openItem && openItem !== item) setOpen(openItem, false);
      setOpen(item, true);
      openItem = item;
    }
    function close(item, returnFocus) {
      clearTimeout(openTimer);
      var target = item || openItem;
      if (!target) return;
      setOpen(target, false);
      if (returnFocus) { var b = target.querySelector('.yb-toggle'); if (b) b.focus(); }
      if (target === openItem) openItem = null;
    }
    function closeAll() { items.forEach(function (i) { setOpen(i, false); }); openItem = null; }

    items.forEach(function (item) {
      var top = item.querySelector('.yb-top');
      var btn = item.querySelector('.yb-toggle');
      var panel = item.querySelector('[data-yb-panel]');

      item.addEventListener('mouseenter', function () {
        if (!desktopMq.matches || !hoverMq.matches) return;
        clearTimeout(closeTimer); clearTimeout(openTimer);
        if (openItem) { open(item); return; }          // already browsing: switch instantly
        openTimer = setTimeout(function () { open(item); }, OPEN_DELAY);
      });
      item.addEventListener('mouseleave', function (e) {
        if (!desktopMq.matches || !hoverMq.matches) return;
        clearTimeout(openTimer);
        // Crossing the strip between the menu row and the open panel keeps it open.
        if (item.classList.contains('is-open') && header && row && header.contains(e.relatedTarget) &&
            e.clientY >= row.getBoundingClientRect().bottom - 4) return;
        closeTimer = setTimeout(function () { close(item); }, CLOSE_DELAY);
      });

      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.classList.contains('is-open')) close(item); else open(item);
      });

      // Touch / pen on a wide screen: first tap opens, second tap follows the link.
      if (top) top.addEventListener('click', function (e) {
        if (!desktopMq.matches || hoverMq.matches) return;
        if (!item.classList.contains('is-open')) { e.preventDefault(); open(item); }
      });

      // Arrow down from a top link or toggle opens the panel and moves into it.
      item.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' && (e.target === top || e.target === btn)) {
          e.preventDefault(); open(item);
          var first = panel && panel.querySelector('a[href]');
          if (first) first.focus();
        }
        if (e.key === 'Escape' && item.classList.contains('is-open')) {
          e.preventDefault(); close(item, true);
        }
      });

      // Close when keyboard focus leaves the item.
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) {
          setTimeout(function () { if (!item.contains(document.activeElement)) close(item); }, 0);
        }
      });
    });

    document.addEventListener('click', function (e) { if (openItem && !nav.contains(e.target)) closeAll(); });
    desktopMq.addEventListener ? desktopMq.addEventListener('change', closeAll) : desktopMq.addListener(closeAll);

    // Keep the panel below the header (sticky header changes height).
    function setMaxHeight() {
      var header = nav.closest('.site-header');
      if (!header) return;
      var bottom = header.getBoundingClientRect().bottom;
      nav.style.setProperty('--yb-top', Math.max(bottom, 0) + 'px');
      Array.prototype.forEach.call(nav.querySelectorAll('[data-yb-panel]'), function (p) {
        p.style.maxHeight = Math.max(window.innerHeight - Math.max(bottom, 0) - 8, 240) + 'px';
      });
    }
    nav.addEventListener('mouseenter', setMaxHeight, true);
    nav.addEventListener('focusin', setMaxHeight);
  }

  /* ---------------- Mobile drawer ---------------- */
  function initDrawer(drawer) {
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer); // escape transformed ancestors
    var bar = document.querySelector('[data-yb-bar]');
    if (bar) {
      if (bar.parentNode !== document.body) document.body.appendChild(bar);
      document.body.classList.add('yb-has-bar');
    }
    var panel = drawer.querySelector('.yb-drawer__panel');
    var tabs = Array.prototype.slice.call(drawer.querySelectorAll('[data-yb-tab]'));
    var openers = Array.prototype.slice.call(document.querySelectorAll('[data-yb-open]'));
    var lastFocus = null;

    function selectTab(name, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-yb-tab') === name;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = drawer.querySelector('[data-yb-tabpanel="' + t.getAttribute('data-yb-tab') + '"]');
        if (p) p.hidden = !on;
        if (on && focus) t.focus();
      });
      var body = drawer.querySelector('.yb-drawer__body');
      if (body) body.scrollTop = 0;
    }
    function setExpanded(v, name) {
      openers.forEach(function (o) {
        o.setAttribute('aria-expanded', v && (o.getAttribute('data-yb-open') === name || o.classList.contains('yb-burger')) ? 'true' : 'false');
      });
    }
    function openDrawer(name, opener) {
      lastFocus = opener || document.activeElement;
      selectTab(name || 'shop');
      drawer.hidden = false;
      docEl.classList.add('yb-lock');
      setExpanded(true, name);
      var first = drawer.querySelector('.yb-tab[aria-selected="true"]');
      if (first) first.focus();
    }
    function closeDrawer() {
      if (drawer.hidden) return;
      drawer.hidden = true;
      docEl.classList.remove('yb-lock');
      setExpanded(false);
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    }

    openers.forEach(function (o) {
      o.addEventListener('click', function (e) {
        e.preventDefault();
        var name = o.getAttribute('data-yb-open');
        if (!drawer.hidden && o.getAttribute('aria-expanded') === 'true') { closeDrawer(); return; }
        openDrawer(name, o);
      });
    });
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-yb-close]'), function (c) {
      c.addEventListener('click', closeDrawer);
    });
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectTab(t.getAttribute('data-yb-tab')); setExpanded(true, t.getAttribute('data-yb-tab')); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') n = tabs[0];
        if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); selectTab(n.getAttribute('data-yb-tab'), true); setExpanded(true, n.getAttribute('data-yb-tab')); }
      });
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex="0"]'), function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    desktopMq.addEventListener ? desktopMq.addEventListener('change', function (m) { if (m.matches) closeDrawer(); })
                               : desktopMq.addListener(function (m) { if (m.matches) closeDrawer(); });

    // The cart drawer (theme) should replace the menu, not sit under it.
    document.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('.js-drawer-open-cart');
      if (c) closeDrawer();
    }, true);

    // Bottom-bar search: go to the top, then open the theme's search panel.
    Array.prototype.forEach.call(document.querySelectorAll('[data-yb-search]'), function (s) {
      s.addEventListener('click', function (e) {
        var headerSearch = document.querySelector('.yb-icons .js-search-header');
        if (!headerSearch) return;              // falls back to /search
        e.preventDefault();
        closeDrawer();
        window.scrollTo(0, 0);
        setTimeout(function () { headerSearch.click(); }, 30);
      });
    });
  }

  function init() {
    var nav = document.querySelector('[data-yb-nav]');
    if (nav) initDesktop(nav);
    var drawer = document.querySelector('[data-yb-drawer]');
    if (drawer) initDrawer(drawer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
